import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import PodcastDetail from "@/pages/PodcastDetail";

export const Route = createFileRoute("/_app/podcasts/$podcastId/")({
  component: () => (
    <PageGate pageKey="podcasts"><PodcastDetail /></PageGate>
  ),
});
